import axios from './axios.js'
import url from './urls.js'

// Bearer token injection — set by adminAuth store on login.
let _token = null
export function setAdminToken(token) {
  _token = token || null
}

function _config() {
  return _token ? { headers: { Authorization: `Bearer ${_token}` } } : {}
}

export default {
  login: (params) => axios.post(url.admin_login, params),
  logout: () => axios.post(url.admin_logout, {}, _config()),
  me: () => axios.get(url.admin_me, _config()),
  changePassword: (params) => axios.post(url.admin_account_change_password, params, _config()),

  // scenarios
  listScenarios: () => axios.get(url.admin_scenarios, _config()),
  getScenario: (id) => axios.get(`${url.admin_scenarios}/${id}`, _config()),
  createScenario: (params) => axios.post(url.admin_scenarios, params, _config()),
  updateScenario: (id, params) => axios.patch(`${url.admin_scenarios}/${id}`, params, _config()),
  enableScenario: (id) => axios.post(`${url.admin_scenarios}/${id}/enable`, {}, _config()),
  disableScenario: (id) => axios.post(`${url.admin_scenarios}/${id}/disable`, {}, _config()),
  deleteScenario: (id) => axios.delete(`${url.admin_scenarios}/${id}`, _config()),

  // flows
  listFlows: (scenario_id) => axios.get(`${url.admin_scenarios}/${scenario_id}/flows`, _config()),
  createFlow: (scenario_id, params) => axios.post(`${url.admin_scenarios}/${scenario_id}/flows`, params, _config()),
  updateFlow: (scenario_id, flow_id, params) => axios.patch(`${url.admin_scenarios}/${scenario_id}/flows/${flow_id}`, params, _config()),
  enableFlow: (scenario_id, flow_id) => axios.post(`${url.admin_scenarios}/${scenario_id}/flows/${flow_id}/enable`, {}, _config()),
  disableFlow: (scenario_id, flow_id) => axios.post(`${url.admin_scenarios}/${scenario_id}/flows/${flow_id}/disable`, {}, _config()),
  deleteFlow: (scenario_id, flow_id) => axios.delete(`${url.admin_scenarios}/${scenario_id}/flows/${flow_id}`, _config()),

  // prompts
  listPrompts: (scenario_id) => axios.get(url.admin_scenario_prompts(scenario_id), _config()),
  getPrompt: (scenario_id, language) => axios.get(url.admin_scenario_prompt_lang(scenario_id, language), _config()),
  createPrompt: (scenario_id, language, params) => axios.post(url.admin_scenario_prompt_lang(scenario_id, language), params, _config()),
  updatePrompt: (scenario_id, language, params) => axios.patch(url.admin_scenario_prompt_lang(scenario_id, language), params, _config()),
  deletePrompt: (scenario_id, language) => axios.delete(url.admin_scenario_prompt_lang(scenario_id, language), _config()),

  // country codes
  listCountryCodes: () => axios.get(url.admin_country_codes, _config()),
  createCountryCode: (params) => axios.post(url.admin_country_codes, params, _config()),
  updateCountryCode: (iso2, params) => axios.patch(`${url.admin_country_codes}/${iso2}`, params, _config()),
  deleteCountryCode: (iso2) => axios.delete(`${url.admin_country_codes}/${iso2}`, _config()),

  // audit log
  listAudit: (params) => axios.get(url.admin_audit, { ..._config(), params }),

  // system
  reloadPrompts: () => axios.post(url.admin_reload_prompts, {}, _config())
}
